<template>
  <div  class="map-sidebar" :class="{visible : showSidebar, double: double}" >
<div class="sidebar-inner">
  <div class="header">
    <div class="sidebar-title"> <slot name="title"></slot></div>
    <div class="close-sidebar" @click="closeSidebar">
      <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4006 20.5996C20.1403 20.8599 19.7181 20.8599 19.4578 20.5996L7.20128 8.34306C6.94093 8.08271 6.94093 7.6606 7.20128 7.40025C7.46163 7.1399 7.88374 7.1399 8.14409 7.40025L20.4006 19.6568C20.661 19.9171 20.661 20.3392 20.4006 20.5996Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2009 20.5996C6.94055 20.3393 6.94055 19.9172 7.2009 19.6568L19.4574 7.40031C19.7178 7.13996 20.1399 7.13996 20.4002 7.40031C20.6606 7.66066 20.6606 8.08277 20.4002 8.34312L8.14371 20.5996C7.88336 20.86 7.46125 20.86 7.2009 20.5996Z" fill="white"/>
      </svg>
    </div>
  </div>
  <div class="sidebar-content">
    <slot></slot>
  </div>
</div>

  </div>
</template>



<script setup lang="ts">
import { ref, onMounted } from 'vue';


const props = defineProps({
  double: {
    type: Boolean,
    default: false
  }
});

const showSidebar = ref(false)

const emit = defineEmits(['close'])

function closeSidebar() {
  showSidebar.value = false;
  window.setTimeout(() => {
    emit('close');
  }, 300);
}

onMounted(() => {
  window.setTimeout(() => {
    showSidebar.value = true;
  }, 50);
})


</script>


